import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useParams, useLocation } from 'react-router-dom';
import { useGetTeacherNewQuestionsQuery } from '../slices/teachers/teacherQuestionsApiSlice';
import {  useSelector } from 'react-redux'

const TeacherNavbar = () => {


  const { pageNumber } = useParams();

  const location = useLocation(); 

  const { teacherInfo } = useSelector((state) => state.authTeacher);

  const { data, isLoading, error } = useGetTeacherNewQuestionsQuery({pageNumber});

  const goToProfile = () => {
    window.open(`${window.location.origin}/teacherpublicprofile/${teacherInfo.user}`, '_blank')
  }

  return (   
    <nav 
    className={`sidenav navbar navbar-vertical  fixed-left  navbar-expand-xs navbar-light bg-white sidebar34 mynav`} 
    id="sidenav-main">
          <div className="scrollbar-inner">
            <div className="sidenav-header  d-flex  align-items-right navLog" >
              <a className="navbar-brand " href=""> <span className="brandcolor">
                Ask to Learn 
                </span>
                <img src="../../../assets/img/log4.png" className="navbar-brand-img" style={{ marginLeft: "2%", height: "180%", marginTop: "-14%",}}  />
              </a>
            </div>
            <div className="navbar-inner">
              <div className="collapse navbar-collapse" id="sidenav-collapse-main"><br />
              <ul className="navbar-nav ">    
                  <div className={`${location.pathname == '/teachernewquestions' ? 'active23' : ''}`}>
                  <li className="nav-item mynav nav-link "> 
                                <i className="ni ni-ungroup text-info navLink nav23"></i>
                                <LinkContainer to='/teachernewquestions' >
                                <span className="nav-link-text navLink navBadge ">
                                    New Questions
                                    <span className="button__badge">
                                        {data?.count}
                                    </span>
                                </span>
                                </LinkContainer>
                  </li>            
                  </div>  
                  <div className={`${location.pathname == '/teachernewsubject' ? 'active23' : ''}`}>
                  <li className={`nav-item mynav nav-link`}> 
                      <i className="ni ni-ui-04 text-success navLink nav23"></i>
                      <LinkContainer to='/teachernewsubject' >
                      <span className="nav-link-text navLink">Create Subject</span>
                      </LinkContainer>
                  </li>               
                  </div> 
                  <div className={`${location.pathname == '/teachersubjects' ? 'active23' : ''}`}>
                  <li className="nav-item mynav nav-link"> 
                      <i className="ni ni-single-copy-04 text-pink navLink nav23"></i>
                      <LinkContainer to='/teachersubjects' >
                      <span className="nav-link-text navLink">My Subjects</span>
                      </LinkContainer>                    
                  </li>
                  </div>
                  <div className={`${location.pathname == '/teacherallstudents' ? 'active23' : ''}`}>
                  <li className="nav-item mynav nav-link"> 
                      <i className="ni ni-align-left-2 text-teal navLink nav23"></i>
                      <LinkContainer to='/teacherallstudents' >
                      <span className="nav-link-text navLink">Active Students</span>
                      </LinkContainer>
                  </li>
                  </div>
                  <div className={`${location.pathname == '/teacherprofile' ? 'active23' : ''}`}>
                  <li className="nav-item mynav nav-link"> 
                      <i className="ni ni-map-big text-success navLink nav23"></i>
                      <LinkContainer to='/teacherprofile' >
                      <span className="nav-link-text navLink">Account</span>                     
                      </LinkContainer>
                  </li>  
                  </div>
                    <li className="nav-item mynav nav-link"> 
                      <i className="ni ni-circle-08 text-primary navLink nav23"></i>
                      <LinkContainer to='' onClick={goToProfile}>
                      <span className="nav-link-text navLink">Public Profile</span>
                      </LinkContainer>
                    </li>   
                    { teacherInfo?.isPaymentSetup ?
                    <div className={`${location.pathname == '/teacherrevenue' ? 'active23' : ''}`}>
                    <li className="nav-item mynav nav-link"> 
                      <i className="ni ni-archive-2 text-teal navLink nav23"></i>
                      <LinkContainer to='/teacherrevenue' >
                      <span className="nav-link-text navLink">Manage Payments</span>
                      </LinkContainer>
                  </li>    
                  </div>
                    :
                  <div className={`${location.pathname == '/teachersetuppayment' ? 'active23' : ''}`}>
                  <li className="nav-item mynav nav-link"> 
                      <i className="ni ni-archive-2 text-teal navLink nav23"></i>
                      <LinkContainer to='/teachersetuppayment' >
                      <span className="nav-link-text navLink">Setup Payouts</span>
                      </LinkContainer>
                  </li>  
                  </div>    
                    }   
                </ul>
              </div>
            </div>
          </div>
    </nav>
      
  )
}

export default TeacherNavbar
